var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"lite"},[_c('img',{attrs:{"src":require("@/assets/lite-badge.svg")}})])
}]

export { render, staticRenderFns }